import { useEffect } from "react"
import Utils from "../../libs/Utils"
import Button from "../Button/Button"
import GUI, { IGUIProps } from "../GUI"

export type ESnackbarTypes = "error"|"info"|"warning"

export type TSnackbarProps = IGUIProps & {
    id:string
    title:any
    msg:string
    type:ESnackbarTypes
    duration:number
    onDismiss?:Function
}

export default function(props:TSnackbarProps) {
    let title:JSX.Element|string|null
    let msg:JSX.Element|string|null = null
    if (props.title && props.title instanceof Object){
        const e = Utils.errorMsg(props.title)
        title = e.title
        msg = e.message
    }
    else if (typeof(props.title)=="string") title = props.title
    else title = null
    
    if (!msg && typeof(props.msg)=="string") msg = props.msg

    useEffect(() => {
        var timeout = setTimeout(onClick, props.duration)
        return () => { clearTimeout(timeout) }
    }, [])

    const onClick = () => props.onDismiss?.()
    return <div className={GUI.joinClass("content", props.className, props.type)}>
        {title ? <h4>{title}</h4> : null}
        {msg ? <p>{msg}</p> : null}
        <div className="actions">
            <Button className="primary" onClick={onClick}>Ok</Button>
        </div>
    </div>
}